import { useTranslate } from '@tolgee/react';
import Copy from './Copy';
import styled from '@emotion/styled';
import { memo } from 'react';
import dayjs from 'dayjs';
import { Button } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { openExternalURL } from 'utils/openExternalURL';

function MercadoLogistics({
  logistics,
  isDetail,
  sellerOrderUrl,
}: {
  logistics: Conversation.Trade.MercadoLogistics;
  isDetail?: boolean;
  sellerOrderUrl?: string;
}) {
  const {
    trackingNumber,
    shipmentId,
    shippingCarrier,
    packageNumber,
    estimatedDeliveryLimitTimeMs,
    logisticsMode,
    trackingInfo,
  } = logistics;

  const { t } = useTranslate();

  return (
    <Container isDetail={String(isDetail)}>
      <dl className={isDetail ? '!items-center' : undefined}>
        <dt className={`flex ${isDetail ? '' : 'justify-between w-full'} items-center`}>
          <span>{t('domain.order.logistics.field.carrier')}</span>
          {sellerOrderUrl ? (
            <Button type="link" onClick={() => openExternalURL(sellerOrderUrl, '__blank')}>
              {t('查看物流')}
              <ExportOutlined />
            </Button>
          ) : null}
        </dt>
        <dd>
          {{
            fulfillment: 'FULL',
            self_service: 'ENVIOS FLEX',
          }[shippingCarrier] || '-'}
        </dd>
      </dl>
      <dl>
        <dt>{t('domain.order.logistics.field.trackingNumber')}</dt>
        <dd>
          {trackingNumber}
          <Copy
            text={trackingNumber}
            successMessage={t('common.feedback.copySuccess')}
            failedMessage={t('common.feedback.copyFailed')}
          />
        </dd>
      </dl>
      <dl>
        <dt>{t('物流面单号')}</dt>
        <dd>
          {shipmentId || '-'}
          {shipmentId ? (
            <Copy
              text={shipmentId}
              successMessage={t('common.feedback.copySuccess')}
              failedMessage={t('common.feedback.copyFailed')}
            />
          ) : null}
        </dd>
      </dl>
      <dl>
        <dt>{t('物流方式')}</dt>
        <dd>{logisticsMode === 'me2' ? 'ME2' : '-'}</dd>
      </dl>
      <dl>
        <dt>{t('预计交货限制')}</dt>
        <dd>
          {Number(estimatedDeliveryLimitTimeMs)
            ? dayjs(Number(estimatedDeliveryLimitTimeMs)).format('YYYY/MM/DD HH:mm')
            : '-'}
        </dd>
      </dl>
      {trackingInfo.map(({ updateTime, description }) => {
        const label = {
          shipped_date: t('domain.order.field.shipmentDate'),
          returned_date: t('domain.order.logistics.field.returnDate'),
          delivered_date: t('domain.order.logistics.field.deliveryDate'),
          cancelled_date: t('domain.order.logistics.field.deliveryCancellationDate'),
          ready_to_ship_date: t('domain.order.logistics.field.readyToShipDate'),
        }[description];

        if (!label) {
          return null;
        }

        return (
          <dl>
            <dt>{label}</dt>
            <dd>
              {Number(updateTime)
                ? dayjs(Number(updateTime)).format(
                    description === 'delivered_date' ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD',
                  )
                : '-'}
            </dd>
          </dl>
        );
      })}
      <dl>
        <dt>{t('domain.order.logistics.field.packageId')}</dt>
        <dd>{packageNumber}</dd>
      </dl>
    </Container>
  );
}

const Container = styled.div<{ isDetail: string }>`
  width: ${({ isDetail }) => (isDetail === 'true' ? '100%' : '260px')};
  > dl {
    display: flex;
    flex-direction: ${({ isDetail }) => (isDetail === 'true' ? 'row' : 'column')};
    align-items: flex-start;
    > dt {
      flex: 0 0 auto;
      margin-right: 8px;
      font-size: 12px;
      font-weight: 400;
      color: var(--fett-text-tertiary);
    }
    > dd {
      flex: 1 0 0;
      display: flex;
      align-items: center;
      margin-bottom: 0;
      font-size: 12px;
    }
  }
`;

export default memo(MercadoLogistics);
